/**
 * Factory: wizard
 */
angular.module('acme.common.factory.wizard', [
  'acme.common.service.validate'
])
.factory('WizardFactory', [ 'ValidateService', function(ValidateService) {

    function Wizard() {}

    Wizard.prototype = {

      constructor: Wizard,

      loop: false,

      allowInvalidNavigation: false,

      currentIndex: 0,

      invalid: [],

      steps: {},

      current: {},

      validators: [],

      order: [],

      errors: [],

      /**
       * Optionally add steps to wizard during init
       *
       * Accepts:
       * Array: [Object: { name: {String} }]
       * Object: { name: {String} }
       * String: {String}
       *
       * @param steps {Array|Object|String}
       * @returns {boolean}
       */
      init: function(steps) {

        var i, ii,
            r = true;

        this.reset();

        if (steps instanceof Array) {
          for (i=0,ii=steps.length;i<ii;i++) {
            if (!this.add(steps[i])) {
              r = false;
              break;
            }
          }
        }else if (typeof(steps) === 'object') {
          r = this.add(steps);
        }else if (typeof(steps) === 'string') {
          r = this.add({
            name: steps
          });
        }

        return r;

      },

      /**
       * Gets the current human readable step
       *
       * @returns {number}
       */
      getStepNumber: function() {
        return this.currentIndex + 1;
      },

      /**
       * Gets a named step object
       *
       * @param name {String}
       * @returns {*|boolean}
       */
      getStep: function(name) {
        return this.steps[name] || false;
      },

      /**
       * Gets the current step name
       *
       * @returns {*}
       */
      getStepName: function() {
        return this.order[this.currentIndex];
      },

      /**
       * Checks for errors
       *
       * @param name {String}
       * @returns {boolean}
       */
      hasErrors: function(name) {
        var step,
            r = false;

        if (name) {
          step = this.getStep(name);
          r = (step && step.errors && step.errors.length > 0);
        }else {
          r = (this.errors.length > 0);
        }

        return r;
      },
      /**
       * Gets all or individual errors for a step
       * An optional field parameter may be passed
       *
       * @param name {String}
       * @param (optional) field {String}
       * @returns {*}
       */
      getErrors: function(name, field) {
        var i, ii,
            r = false,
            step = this.getStep(name);

        if (step && step.errors) {
          if (field) {
            for (i = 0, ii = step.errors.length; i < ii; i++) {
              if (step.errors[i].payload.hasOwnProperty('field') &&
                  step.errors[i].payload.field === field) {
                return step.errors[i];
              }
            }
          } else {
            r = step.errors;
          }
        }

        return r;

      },

      /**
       * Reset the entire object
       *
       */
      reset: function() {
        this.invalid = [];
        this.errors = [];
        this.steps = {};
        this.order = [];
        this.current = {};
        this.loop = false;
        this.currentIndex = 0;
      },

      /**
       * Adds a new step to the wizard
       *
       * Accepts:
       * {
       *   name: {String}
       * }
       *
       * @param props {Object}
       * @returns {boolean}
       */
      add: function(props) {

        var r = false;

        if (!this.getStep(props.name)) {
          this.steps[props.name] = props;
          this.order.push(props.name);
          r = true;
        }

        return r;
      },

      /**
       * Removes a step from the wizard
       *
       * @param name {Object}
       * @returns {boolean}
       */
      remove: function(name) {
        var tmpLoop,
            r = false;

        if (this.getStep(name)) {

          // Move to the next step if current step is the one being removed
          if (this.current.name === name) {
            // Temporarily enable looping so next will work if we are removing the last element
            tmpLoop = this.loop;
            this.loop = true;
            // Move to the next step in the wizard
            this.next();
            // Reset looping to original value
            this.loop = tmpLoop;
          }
          // Remove the step
          this.steps[name] = null;
          delete this.steps[name];
          // Remove update the order to reflect the removal
          this.order.splice(this.order.indexOf(name), 1);
          r = true;
        }

        return r;
      },

      addValidator: function(step, validator) {

        var r = false;

        if (this.getStep(step)) {
          this.steps[step].validators.push(validator);
          r = {
            index: this.steps[step].validators.length - 1
          };
        }

        return r;
      },

      removeValidator: function(step, field) {

        var i, ii,
            r = false;

        if (this.getStep(step)) {
          for (i=0,ii=this.steps[step].validators.length;i<ii;i++) {
            if (this.steps[step].validators[i].field === field) {
              this.steps[step].validators.splice(i, 1);
              r = true;
              break;
            }
          }
        }

        return r;
      },

      /**
       * Executes validators within steps
       *
       * @returns {boolean}
       */
      validate: function() {

        var i, ii;

        this.invalid = [];

        for (i=0,ii=this.order.length;i<ii;i++) {
          if (this.steps[this.order[i]].hasOwnProperty('validators') && this.steps[this.order[i]].validators instanceof Array) {
            if (!ValidateService.validate(this.steps[this.order[i]].validators)) {
              // Set valid property for step
              this.steps[this.order[i]].valid = false;
              // Get fields which passed
              this.steps[this.order[i]].passed = ValidateService.passed;
              // Add invalid step names to a single location
              this.invalid.push(this.order[i]);
              // Add errors to appropriate step
              this.steps[this.order[i]].errors = ValidateService.errors;
              // Skip setting valid state to true if there are errors
              continue;
            }
          }
          // Set valid property for step if there are no errors
          this.steps[this.order[i]].valid = true;
          // Get steps which passed
          this.steps[this.order[i]].passed = ValidateService.passed;
          // Reset errors on step
          this.steps[this.order[i]].errors = [];
        }

        return (this.invalid.length === 0);

      },

      /**
       * Checks if current step is invalid
       *
       * @returns {boolean}
       */
      invalidCheck: function() {
        this.validate();
        return (!this.allowInvalidNavigation && !this.isValid(this.order[this.currentIndex]));
      },

      /**
       * Checks if current step is valid and initialized
       *
       * @param name {String}
       * @param (optional) field {String}
       * @returns {boolean}
       */
      validCheck: function(name, field) {

        var r = true;

        if (this.isValidSet(name)) {
          r = this.isValid(name, field);
        }

        return r;

      },


      /**
       * Return validated state of a step
       * An optional field parameter may be passed
       *
       * @param name {String}
       * @param (optional) field {String}
       * @returns {boolean}
       */
      isValid: function(name, field) {
        var r,
            step = this.getStep(name);

        if (field) {
          r = (step.passed && step.passed.indexOf(field) >= 0);
        }else{
          r = (step.valid === true);
        }

        return r;
      },

      /**
       * Returns if valid flag is set
       *
       * @param name {String}
       * @returns {boolean}
       */
      isValidSet: function(name) {
        return (this.getStep(name).hasOwnProperty('valid'));
      },

      /**
       * Verifies named parameter is the current step
       *
       * @param name {String}
       * @returns {boolean}
       */
      isStep: function(name) {
        return (this.order[this.currentIndex] === name);
      },

      isFirst: function() {
        return (this.currentIndex === 0);
      },

      isLast: function() {
        return (this.currentIndex === this.order.length - 1);
      },

      /**
       * Assign next step to current object
       *
       * If loop is true the next step is the
       *   first step in the order array
       * Otherwise it is the
       *   last step in the order array
       *
       * @returns {number}
       */
      next: function(props) {

        if (this.invalidCheck())  {
          return false;
        }

        var next = (this.currentIndex + 1 < this.order.length) ? this.order[this.currentIndex + 1] : false;

        if (next) {
          this.currentIndex += 1;
        }else if (this.loop) {
          this.currentIndex = 0;
        }

        this.current = this.steps[this.order[this.currentIndex]];

        this.callback(props);

        return this.currentIndex;

      },

      /**
       * Assign back step to current object
       *
       * If loop is true the back step is the
       *   last step in the order array
       * Otherwise it is the
       *   first step in the order array
       *
       * @returns {*}
       */
      back: function(props) {

        if (this.invalidCheck())  {
          return false;
        }

        var back = this.order[this.currentIndex - 1];

        if (back) {
          this.currentIndex -= 1;
        }else if (this.loop) {
          this.currentIndex = this.order.length - 1;
        }

        this.current = this.steps[this.order[this.currentIndex]];

        this.callback(props);

        return this.currentIndex;

      },

      /**
       * Advances pointer to named state
       *
       * @param name {String}
       * @returns {boolean}
       */
      setCurrentStep: function(name) {

        var r = false,
          step = this.getStep(name);

        if (this.invalidCheck()) {
          return false;
        }

        if (step) {
          this.current = step;
          this.currentIndex = this.order.indexOf(name);
          r = true;
        }

        return r;

      },

      /**
       * Skip to the last step in the order array
       *
       * @returns {*}
       */
      last: function(props) {

        if (this.invalidCheck())  {
          return false;
        }

        this.currentIndex = this.order.length - 1;
        this.current = this.steps[this.order[this.currentIndex]];

        this.callback(props);

        return this.currentIndex;

      },

      /**
       * Skip to the first step in the order array
       *
       * @returns {*}
       */
      first: function(props) {

        if (this.invalidCheck())  {
          return false;
        }

        this.currentIndex = 0;
        this.current = this.steps[this.order[this.currentIndex]];

        this.callback(props);

        return this.currentIndex;

      },

      /**
       * Complete the wizard
       *
       * @returns {boolean}
       */
      done: function(props) {

        var r = this.validate();

        if (r) {
          this.callback(props);
        }

        return r;

      },


      /**
       * Performs scoped or unscoped callback
       *
       * Accepts:
       * {
       *   callback: {Function}
       *   scope: {$scope} Reference to scope
       *   args: {Array}
       * }
       *
       * @param o
       * @returns {boolean}
       *
       */
      callback: function(o) {

        var r = false;

        if (o && o.hasOwnProperty('callback') && typeof(o.callback) === 'function') {

          if (o.scope) {
            r = o.callback.call(o.scope);
            if (o.args && o.args.length > 0) {
              r = o.callback.apply(o.scope, o.args);
            }
          } else {
            r = o.callback();
          }

        }

        return r;
      }

    };

    return Wizard;

}]);